module.exports = __webpack_public_path__ + "static/media/weiboQR.ac9bb31b.png";